'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/react/react.js
 ** module id = 24
 ** module chunks = 0 1 2 3 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29
 **/